import { createContext, useContext } from 'react';
import type { PermissionKey } from '@pm/contracts';

type SessionAccess = {
  global: PermissionKey[];
  anyScope: PermissionKey[];
  roleNames: string[];
  isAdmin?: boolean | undefined;
};

const AccessContext = createContext<SessionAccess>({
  global: [],
  anyScope: [],
  roleNames: [],
});

export function AccessProvider({
  access,
  children,
}: React.PropsWithChildren<{ access: SessionAccess }>) {
  return <AccessContext.Provider value={access}>{children}</AccessContext.Provider>;
}

export function useAccess() {
  const access = useContext(AccessContext);
  return {
    ...access,
    isAdmin: access.isAdmin ?? access.roleNames.includes('Admin'),
    hasGlobal: (permission: PermissionKey) => access.global.includes(permission),
    hasAny: (permission: PermissionKey) => access.anyScope.includes(permission),
  };
}
